'use strict';

var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol['for'] && Symbol['for']("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

module.exports = _react2['default'].createClass({
    displayName: 'API User Images',

    getDefaultProps: function getDefaultProps() {
        return {
            apiUsersHeaderText: 'LOOK WHO\'S USING HELLOSIGN'
        };
    },

    renderImages: function renderImages() {
        var imageData = this.props.apiUsersImageData;
        return imageData.map(function (data, index) {
            var imageProps = {
                className: 'l-vertical-align',
                src: data.imageUrl,
                height: data.style.height,
                width: data.style.width
            };
            return _jsx('li', {
                className: 'm-feature-grid--list-item small-text-center'
            }, index, _jsx('div', {
                className: 'm-feature-grid--item-image-wrapper'
            }, void 0, _react2['default'].createElement('img', imageProps)));
        });
    },

    render: function render() {
        return _jsx('div', {}, void 0, _jsx('div', {
            className: 'small-12 small-centered small-text-center columns'
        }, void 0, _jsx('div', {
            className: 'l-padding-b-10'
        }, void 0, _jsx('h6', {
            className: 'm-marketing-page--subheader-small c-ashen',
            style: { fontSize: 18 }
        }, void 0, this.props.apiUsersHeaderText))), _jsx('div', {
            className: 'bg-plume m-feature-grid m-hs-companies--grid m-hs-companies--api--grid medium-12 columns'
        }, void 0, _jsx('div', {
            className: 'row'
        }, void 0, _jsx('div', {
            className: 'small-text-center'
        }, void 0, _jsx('ul', {
            className: 'm-feature-grid--list-item-group small-block-grid-2 medium-block-grid-6'
        }, void 0, this.renderImages())))));
    }
});


/*****************
 ** WEBPACK FOOTER
 ** ./src/landing-pages/components/common/api-user-images.jsx
 ** module id = 816
 ** module chunks = 0
 **/